import React from 'react';
import type { HistoricalRecord } from '../../types';
import { Badge } from '../ui/Badge';
import { formatMetricLabel, formatDateRange } from '../../utils/calculations';
interface HistoryTableProps {
  records: HistoricalRecord[];
}
export function HistoryTable({
  records
}: HistoryTableProps) {
  if (records.length === 0) {
    return <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-6 py-12 text-center" data-id="element-203">
        <p className="text-sm text-gray-500" data-id="element-204">
          No historical records match the selected filters.
        </p>
      </div>;
  }
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-205">
      <div className="overflow-x-auto" data-id="element-206">
        <table className="w-full text-sm" aria-label="Historical records table" data-id="element-207">
          <thead data-id="element-208">
            <tr className="bg-gray-50 border-b border-gray-100" data-id="element-209">
              <th className="text-left px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-210">
                Period
              </th>
              <th className="text-left px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-211">
                Entity
              </th>
              <th className="text-left px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-212">
                Type
              </th>
              <th className="text-left px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-213">
                Metric
              </th>
              <th className="text-right px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-214">
                Target
              </th>
              <th className="text-right px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-215">
                Actual
              </th>
              <th className="text-right px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-216">
                %
              </th>
              <th className="text-center px-6 py-3 font-medium text-gray-500 uppercase text-xs tracking-wider" data-id="element-217">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-218">
            {records.map((record, index) => <tr key={record.id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 1 ? 'bg-gray-50/50' : ''}`} data-id="element-219">
                <td className="px-6 py-3.5 text-gray-600 whitespace-nowrap" data-id="element-220">
                  <div data-id="element-221">
                    <span className="capitalize text-xs font-medium text-gray-400 block" data-id="element-222">
                      {record.periodType}
                    </span>
                    <span className="text-gray-700" data-id="element-223">
                      {formatDateRange(record.startDate, record.endDate)}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-3.5 font-medium text-gray-900" data-id="element-224">
                  {record.entityName}
                </td>
                <td className="px-6 py-3.5 text-gray-500 capitalize" data-id="element-225">
                  {record.entityType}
                </td>
                <td className="px-6 py-3.5 text-gray-700" data-id="element-226">
                  {formatMetricLabel(record.metric)}
                </td>
                <td className="px-6 py-3.5 text-right text-gray-600" data-id="element-227">
                  {record.target}
                </td>
                <td className="px-6 py-3.5 text-right font-semibold text-gray-900" data-id="element-228">
                  {record.actual}
                </td>
                <td className="px-6 py-3.5 text-right font-medium text-gray-700" data-id="element-229">
                  {record.percentage.toFixed(1)}%
                </td>
                <td className="px-6 py-3.5 text-center" data-id="element-230">
                  <Badge status={record.achieved ? 'achieved' : 'missed'} size="sm" data-id="element-231" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}